export default __webpack_public_path__ + "static/media/gh.975f5039.svg";